/**
 * Microsoft Planner Service
 * Read-only toegang tot Planner-plans via Microsoft Graph API. Gebruikt
 * voor de MT-Planner widget op de strategiepagina.
 *
 * Scope: Tasks.ReadWrite (zelfde delegated scope als To-Do — dekt Planner
 * voor de tenant van de ingelogde user).
 */

const GRAPH_BASE = 'https://graph.microsoft.com/v1.0';

async function getAccessToken(msalInstance) {
  const account = msalInstance.getActiveAccount();
  if (!account) throw new Error('Geen actief MSAL-account');
  const request = { scopes: ['Tasks.ReadWrite'], account };
  try {
    const response = await msalInstance.acquireTokenSilent(request);
    return response.accessToken;
  } catch (err) {
    const response = await msalInstance.acquireTokenPopup(request);
    return response.accessToken;
  }
}

async function graphGet(msalInstance, path) {
  const token = await getAccessToken(msalInstance);
  const res = await fetch(`${GRAPH_BASE}${path}`, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
  });
  if (!res.ok) {
    let body = '';
    try { body = await res.text(); } catch {}
    throw new Error(`Graph ${path}: HTTP ${res.status}${body ? ' — ' + body.slice(0, 200) : ''}`);
  }
  return res.json();
}

export async function getPlannerPlan(msalInstance, planId) {
  return graphGet(msalInstance, `/planner/plans/${planId}`);
}

export async function getPlannerTasks(msalInstance, planId) {
  const json = await graphGet(msalInstance, `/planner/plans/${planId}/tasks`);
  return json.value || [];
}

export async function getPlannerBuckets(msalInstance, planId) {
  const json = await graphGet(msalInstance, `/planner/plans/${planId}/buckets`);
  return json.value || [];
}
